import { Theme } from '@aptuno/aptuno-ui';
import Footer from '@components/commons/Footer/Footer';
import { estateDefaultValue, EstateActionsContext } from '@contexts/Estate';
import React, { FC } from 'react';
import { GridLayout, MainGridLayout } from './ListingDetailsLayout.styled';

interface ListingDetailsLayoutProps {
  // todo: define correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageProps?: any;
}

const ListingDetailsLayout: FC<ListingDetailsLayoutProps> = ({ children, pageProps }) => {
  return (
    <Theme colorModes="light">
      <EstateActionsContext.Provider value={estateDefaultValue}>
        <MainGridLayout>
          <GridLayout {...pageProps}>{children}</GridLayout>
          <Footer />
        </MainGridLayout>
      </EstateActionsContext.Provider>
    </Theme>
  );
};

export default ListingDetailsLayout;
